<template>
<section
    class="pb-14 md:pb-16 lg:pb-[88px] xl:pb-[100px] pt-28 md:pt-32 lg:pt-44 xl:pt-[200px] relative overflow-hidden about"
  >
    <div class="container">
      <!-- Content Wrapper -->
      <div
        class="flex flex-col items-center lg:items-stretch justify-center lg:justify-normal reveal-me"
      >
  
        <!-- About Description -->
        <h3 class="mt-[34px] mx-auto reveal-text relative overflow-hidden">
          We create next-level experiences  
          <br class="hidden sm:block" />
          that seamlessly merge design, innovation,  
          <br class="hidden sm:block" />
          and cutting-edge technology.
          <br />
          <br />
          Our tailored solutions elevate brands,  
          <br class="hidden sm:block" />
          whether refining your current brand or  
          <br class="hidden sm:block" />
          crafting a powerful neue one from scratch.
        </h3>
      </div>
    </div>
  </section>
</template>

<script>
import { Animations } from '@/legacy/initLegacy';
export default {
  name: 'BrandSpinner',
  mounted() {
    Animations.initTextReveal();
  },
  activated() {
    this.$nextTick(() => {
      Animations.initTextReveal();
    });
  },
  watch: {
    $route() {
      this.$nextTick(() => {
        Animations.initTextReveal();
      });
    }
  }
};
</script>
  